import React, {useEffect, useRef, useState} from "react";
import {Carousel} from 'antd';
import "./TSliderDesktop.scss"
import {LazyImage} from "..";

import {Swiper, SwiperSlide} from 'swiper/react';
import SwiperCore, { Autoplay } from 'swiper';

function TSliderDesktop({item}) {

    SwiperCore.use([Autoplay])


    const [sliders,set_sliders] = useState([])
    const [rTop,set_rTop] = useState({})
    const [rBot,set_rBot] = useState({})

    useEffect(()=>{
        let rB = item.items.find(i=>i.position ==="right_bottom")
        let rT = item.items.find(i=>i.position ==="right_top")
        let sl = item.items.filter(i=>i.position ==="left")

        set_rTop(rT)
        set_rBot(rB)
        set_sliders(sl)


    },[])

    const onChange = (currentSlide) => {
        console.log(currentSlide);
    };
    return (
        <div>

            <br/>
            <div className="tSlider-cont">
                <div className="tSlider-slide">
                    <Swiper
                        autoplay={{
                            delay: 3000,
                            pauseOnMouseEnter: true,
                            disableOnInteraction: false
                        }}
                        loop
                        spaceBetween={50}
                        slidesPerView={1}
                        onSlideChange={() => console.log('slide change')}
                        onSwiper={(swiper) => console.log(swiper)}
                    >

                        {sliders.map(item=>{
                            return(
                                <SwiperSlide>
                                    <img alt={"slider"+item.uid}  src={item.image_desktop} />
                                </SwiperSlide>
                            )
                        })}
                        <br/>
                    </Swiper>
                    {/*<img*/}
                    {/*    src={"https://test-loyalty-minio.darkube.app/loyalty-media/page/section_item/desktop_images/06_Desktop_sskJCy3.jpg"}*/}
                    {/*    alt=""/>*/}
                </div>
                <div className="tSlider-items" style={{paddingLeft:8}}>
                    <div className="tSlider-items-desktop">
                        <img
                            src={rTop?.image_desktop}
                            alt=""/>
                    </div>

                    <div className="tSlider-item-divider"></div>
                    <div className="tSlider-items-desktop">
                        <img
                            src={rBot?.image_desktop}
                            alt=""/>
                    </div>
                </div>
            </div>


            {/*<div className="tSlider-container">*/}

            {/*    <div className="tSlider-left">*/}
            {/*        <div className="tSlider-slide">*/}
            {/*            <img src="https://test-loyalty-minio.darkube.app/loyalty-media/page/section_item/desktop_images/07_Desktop.jpg" alt=""/>*/}
            {/*        </div>*/}
            {/*    </div>*/}

            {/*    <div className="tSlider-right">*/}
            {/*        <div className="tSlider-items">*/}

            {/*            <div className="tSlider-item">*/}
            {/*                <img src="https://test-loyalty-minio.darkube.app/loyalty-media/page/section_item/desktop_images/1_TT98dcZ.png" alt=""/>*/}
            {/*            </div>*/}

            {/*            <div className="tSlider-item-divider"></div>*/}
            {/*            <div className="tSlider-item">*/}
            {/*                <img src="https://test-loyalty-minio.darkube.app/loyalty-media/page/section_item/desktop_images/4_h3tt6mN.png" alt=""/>*/}
            {/*            </div>*/}

            {/*        </div>*/}
            {/*    </div>*/}

            {/*</div>*/}
        </div>
        /*<div style={props.item.order!==1?{margin: "32px 16px 0 16px"}:{}}>
            {props.item.title?<div className="section-title"><span>{props.item.title}</span></div>:null}
        <div className="slider_container"
             style={{overflowX:"hidden",backgroundImage: props.item && props.item.background_image? `url(${props.item.background_image})` : ''}}
        >
            {props.data?<div className={`swiper-container-${props.uid} swiper1`}>
                <div className="swiper-wrapper">
                    {props.data.map(item=>{
                        return(
                            <div key={item.uid} className="swiper-slide" >
                                <img alt={"slider"+item.uid}  src={item.image} />
                                {/!*<LazyImage type={"slide"} src={item.image}/>*!/}
                            </div>
                        )
                    })}
                </div>
            </div>:null}
        </div>
        </div>*/
    )
}

export {TSliderDesktop};
